














import { defineComponent, ref, watch } from '@vue/composition-api';

import useDeliveryNoteStatus from '@/useDeliveryNote';

const CommonDeliveryNoteStatusSelect = defineComponent({
  props: {
    value: { default: 'PENDING' },
    label: { default: '' },
    icon: { default: '' },
    placeholder: { default: 'เลือกสถานะ' },
  },
  setup(props: any) {
    const { english: list, thai: display } = useDeliveryNoteStatus();
    const _value = ref('PENDING');
    watch(() => props.value, (newVal, oldVal) => {
      if (newVal !== oldVal && newVal !== _value.value) _value.value = newVal;
    });

    return {
      list: ['', ...list],
      display: ['ทั้งหมด', ...display],
      _value,
    };
  },
});

export default CommonDeliveryNoteStatusSelect;
